import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  TASK: {
    DELETE_TASK_USER: (taskId, userId, callback) => ({ taskId, userId, callback }),
    API: {
      DELETE_TASK_USER: apiResourceActionCreator('task')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.delete(`${API_ENDPOINT}/${payload.taskId}/user/${payload.userId}`, authToken, actions.task.api.deleteTaskUser);

function* deleteTaskUser(action) {
  const authToken = yield select(authTokenSelector);

  yield put(apiAction(authToken, action.payload));

  const result = yield apiActionResult(actions.task.api.deleteTaskUser);

  if (result.success) {
    action.payload.callback()
  }
}

const configuration = {
  name: 'deleteTaskUser',
  action: actions,
  sagas: deleteTaskUser,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/deleteTaskUser.js